import React, { useState, useEffect } from "react";
import {
	Button,
	Form,
	Input,
	Select,
	Row,
	message,
	Col,
	Card,
	notification,
	Tabs,
	Upload,
	AutoComplete,
	Checkbox,
	Radio,
	DatePicker,
} from "antd";
import {
	MinusCircleOutlined,
	FileTextOutlined,
	PlusOutlined,
	InboxOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import userService from "../../services/user";
import equipmentService from "../../services/equipments";
import equipmentRequestService from "../../services/equipmentRequest";

import sapService from "../../services/sap";
import departmentService from "../../services/department";
import designationService from "../../services/designation";
import employeeService from "../../services/user";

import DefaultLayout from "../../components/layout/DefaultLayout";
import Header from "../../components/header";
import "./index.css";
import InventoryAssetComponent from "../../components/InventoryAsset";
import EquipmentCalculatComponent from "../../components/EquipmentCalculate";
import SapLocationComponent from "../../components/sapLocation";
import CostCenterComponent from "../../components/costCenter";
import DepartmentComponent from "../../components/department";
import SapTypeComponent, { sapTypes } from "../../components/sapType";
import SapPlantComponent from "../../components/sapPlant";
import CompanyComponent from "../../components/company";
import ParamComponent from "../../components/param";
import UserComponent from "../../components/user";
import DesignationComponent from "../../components/designation";

// FOR CUSTOM FIELDS
import customFieldService from "../../services/customField";
import commonCrud from "../../services/commonCrud";
import dayjs from "dayjs";
import RenderCustomFields from "../../components/renderCustomFields";
// import { set } from "core-js/core/dict";

// import { Editor } from '@tinymce/tinymce-react';

const toFormData = (obj, form = null, namespace = "") => {
	const fd = form || new FormData();
	let formKey;

	for (const property in obj) {
		if (Object.prototype.hasOwnProperty.call(obj, property)) {
			if (namespace) {
				formKey = namespace + "[" + property + "]";
			} else {
				formKey = property;
			}

			const value = obj[property];

			if (value === undefined) continue;

			if (value instanceof File || value instanceof Blob) {
				fd.append(formKey, value);
			} else if (value && typeof value.toISOString === "function") {
				fd.append(formKey, value.toISOString());
			} else if (value && typeof value === "object") {
				toFormData(value, fd, formKey);
			} else {
				fd.append(formKey, value === null ? "" : value);
			}
		}
	}

	return fd;
};

const PostEquipmentRequest = () => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const { currentUser } = useSelector((state) => state.user);
	const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
	const [editMode, setEditMode] = useState(false);
	const [editingEquipmentRequest, setEditingEquipmentRequest] = useState(null);
	const [isDraft, setIsDraft] = useState(null);
	const defaultLocationId = currentUser ? currentUser.location.id : null;
	const defaultDeparmentId = currentUser ? currentUser.department.id : null;
	const defaultDeparmentName = currentUser ? currentUser.department.name : null;
	const [departmentOptions, setDepartmentOptions] = React.useState([]);
	const [designationOptions, setDesignationOptions] = React.useState([]);
	const [employeeOptions, setEmployeeOptions] = React.useState([]);
	const [formattedData, setFormattedData] = useState({});

	const compId =
		currentUser && currentUser.company ? currentUser.company.id : 1;
	// const defaultCompanyId = currentUser ? currentUser.department.id : null;

	const { TabPane } = Tabs;
	const [deletedAttachments, setDeletedAttachments] = useState([]);
	const [fileList, setFileList] = useState([]);
	const [selectedLocations, setSelectedLocations] = useState([]);
	const [selectedPlants, setSelectedPlants] = useState([]);
	const [emailOptions, setEmailOptions] = React.useState([]);

	const [editInvMode, setEditInvMode] = useState(false);

	const { id } = useParams();
	const navigate = useNavigate();

	const [companyId, setCompanyId] = useState(null);

	// FOR CUSTOM FIELDS
	const [customfields, setCustomFields] = useState([]);
	const [dynamicOptions, setDynamicOptions] = useState({});

	// Custom fields
	const getCustomFields = async (page = 1) => {
		setLoading(true);
		await customFieldService.getcustomFields(7).then((response) => {
			const sorted = [...response].sort((a, b) => a.sort - b.sort);
			setCustomFields(sorted);
			setLoading(false);
		});
	};

	const fetchDynamicOptions = async (
		reference,
		dataType = "dynamic",
		sortOption = "none",
	) => {
		if (!reference) return;

		if (dynamicOptions[reference]) return; // already cached

		try {
			console.log("fetchDynamicOptions for", reference);

			// --- handle lookups separately ---
			if (dataType === "lookups") {
				const response = await commonCrud.lookups(reference);
				if (response && Array.isArray(response)) {
					let options = response.map((val) => ({ label: val, value: val }));

					// 🔽 sort by option
					if (sortOption === "asc") {
						options.sort((a, b) => a.label.localeCompare(b.label));
					} else if (sortOption === "desc") {
						options.sort((a, b) => b.label.localeCompare(a.label));
					}

					setDynamicOptions((prev) => ({ ...prev, [reference]: options }));
				}
				return;
			}

			// --- map of dynamic APIs ---
			const apiMap = {
				departments: commonCrud.departments,
				cost_centers: commonCrud.cost_centers,
				users: () => commonCrud.users("all"),
				projects: commonCrud.projects,
				sections: commonCrud.sections,
				categories: commonCrud.categories,
				designations: commonCrud.designations,
				locations: commonCrud.locations,
				equipments: commonCrud.equipments,
				forms: commonCrud.forms,
				subscribers: commonCrud.subscribers,
				approvers: () => commonCrud.approvers(1, 100),
				makes: () => commonCrud.makes(1, 100),
				companies: () => commonCrud.companies(1, 100),
				services: () => commonCrud.services(1, 100),
			};

			const fetchFn = apiMap[reference];
			if (!fetchFn) {
				console.warn(`No API found for reference: ${reference}`);
				return;
			}

			const response = await fetchFn();
			if (response && Array.isArray(response)) {
				let options = response.map((item) => ({
					label: item.name || item.title || item.cost_center || item.id,
					value: item.id,
				}));

				// 🔽 Apply sort_options logic
				if (sortOption === "asc") {
					options.sort((a, b) => a.label.localeCompare(b.label));
				} else if (sortOption === "desc") {
					options.sort((a, b) => b.label.localeCompare(a.label));
				}

				setDynamicOptions((prev) => ({ ...prev, [reference]: options }));
			}
		} catch (error) {
			console.error(`Failed to fetch ${reference} options:`, error);
		}
	};

	useEffect(() => {
		if (customfields.length > 0) {
			customfields.forEach((f) => {
				if (
					(f.data_type === "dynamic" || f.data_type === "lookups") &&
					f.data_reference
				) {
					fetchDynamicOptions(f.data_reference, f.data_type, f.sort_options);
				}
			});
		}
	}, [customfields]);

	const handleRequirementChange = (index, values) => {
		setSelectedCheckboxes((prev) => {
			const newCheckboxes = [...prev];
			newCheckboxes[index] = values;
			return newCheckboxes;
		});
	};

	useEffect(() => {
		const fetchData = async () => {
			try {
				if (id) {
					setLoading(true);
					setEditMode(true);

					const response = await sapService.getSapById(id);
					setLoading(false);

					setFormattedData(response);
					console.log("IsDraft ", response.draft_at);
					console.log("status ", response.status);

					let typeId = response.sap_access_type
						? typeof response.sap_access_type === "object"
							? response.sap_access_type.id
							: response.sap_access_type
						: response.type
							? typeof response.type === "object"
								? response.type.id
								: response.type
							: response.sap_access_type_id;
					let typeName = response.sap_access_type
						? typeof response.sap_access_type === "object"
							? response.sap_access_type.name
							: response.sap_access_type
						: response.type
							? typeof response.type === "object"
								? response.type.name
								: response.type
							: "";

					// If typeId is string (old data), try to map to ID
					if (typeof typeId === "string") {
						const found = sapTypes.find(
							(t) => t.type === typeId || t.name === typeId,
						);
						if (found) {
							typeId = found.id;
							typeName = found.type;
						} else {
							// If not found in map, maybe it is "Modification" string
							if (typeId === "Modification") {
								// Fallback if not in sapTypes for some reason
								typeName = "Modification";
							}
						}
					} else if (typeof typeId === "number") {
						const found = sapTypes.find((t) => t.id === typeId);
						if (found) typeName = found.type;
					}

					if (
						typeName === "Modification" ||
						typeName === "Transfer of ID" ||
						typeName === "Sac ID" ||
						typeName === "SAP ID deactivation"
					) {
						setIsModification(true);
					}

					const locationIds = response.data.location.map((item) => item.id);
					const plantIds = response.data.plant.map((item) => item.id);
					setSelectedLocations(locationIds.map((item) => Number(item)));
					setSelectedPlants(plantIds.map((item) => Number(item)));

					setCompanyId(response?.company_id);

					console.log("response", response);

					// Initialize form values with proper handling for null/undefined
					const initialValues = {
						request_title: response.request_title || "",
						company_id: response.company?.id || "",
						for_email: response.for_email || "",
						for_department: response.for_department || "",
						for_designation: response.for_designation || "",
						for_employee: response.for_employee || "",
						location: locationIds.map((item) => Number(item)),
						sap_access_type_id: typeId,
						sap_id: response.sap_id || "",
						roles_required: response.roles_required || "",
						tcode_required: response.tcode_required || "",
						plant: plantIds,
						business_justification: response.business_justification || "",
					};

					// Sales Distribution
					if (response.data.sales_distribution?.length) {
						initialValues.sales_distribution = response.data.sales_distribution;
					} else {
						initialValues.sales_distribution = [
							{
								sales_organization: [],
								distribution_channel: [],
								division: [],
								sales_office: [],
								sales_group: [],
								other_details: "",
							},
						];
					}

					// Material Management
					if (response.data.material_management?.length) {
						initialValues.material_management =
							response.data.material_management;
					} else {
						initialValues.material_management = [
							{
								purchasing_org: [],
								purchasing_group: [],
								storage_location: "",
								purchasing_document: "",
								movement_type: "",
								other_details: "",
							},
						];
					}

					// Plant Maintenance
					if (response.data.plant_maintenance?.length) {
						initialValues.plant_maintenance = response.data.plant_maintenance;
					} else {
						initialValues.plant_maintenance = [
							{
								planning_plant: [],
								maintenance_plant: [],
								work_centers: [],
								other_details: "",
							},
						];
					}

					// Financial Accounting & Costing
					if (response.data.financial_accounting_costing?.length) {
						initialValues.financial_accounting_costing =
							response.data.financial_accounting_costing;
					} else {
						initialValues.financial_accounting_costing = [
							{
								profile_center: [],
								cost_center: [],
								other_details: "",
							},
						];
					}

					// Production Planning
					if (response.data.production_planning?.length) {
						initialValues.production_planning =
							response.data.production_planning;
					} else {
						initialValues.production_planning = [
							{
								other_details: "",
							},
						];
					}

					// Human Resource
					if (response.data.human_resource?.length) {
						initialValues.human_resource = response.data.human_resource;
					} else {
						initialValues.human_resource = [
							{
								personnel_area: [],
								sub_area: [],
								cost_center: [],
								employee_group: [],
								employee_sub_group: [],
								other_details: "",
							},
						];
					}

					form.setFieldsValue(initialValues);

					// ✅ FOR CUSTOM FIELDS
					if (response.custom_fields && response.custom_fields.length > 0) {
						const customFieldValues = {};

						response.custom_fields.forEach((item) => {
							const fieldKey = `field_${item.custom_field.id}`;
							const label = item.custom_field.label?.toLowerCase() || "";
							const type = item.custom_field.type;

							if (
								label.includes("date") ||
								label.includes("dob") ||
								label.includes("day")
							) {
								const parsedDate = dayjs(item.value);
								customFieldValues[fieldKey] = parsedDate.isValid()
									? parsedDate
									: null;
							} else if (type === "Multi") {
								customFieldValues[fieldKey] = item.value
									? item.value.split(",").map((v) => v.trim())
									: [];
							} else {
								customFieldValues[fieldKey] = item.value;
							}
						});

						response.custom_fields.forEach((item) => {
							const fieldKey = `field_${item.custom_field.id}`;
							const label = item.custom_field.label?.toLowerCase() || "";
							const type = item.custom_field.type;

							if (
								type === "Date" ||
								type === "Datetime" ||
								label.includes("date") ||
								label.includes("dob") ||
								label.includes("day")
							) {
								const parsedDate = dayjs(item.value);
								customFieldValues[fieldKey] =
									dayjs.isDayjs(parsedDate) && parsedDate.isValid()
										? parsedDate
										: null;
							} else if (type === "Multi") {
								customFieldValues[fieldKey] = item.value
									? item.value.split(",").map((v) => v.trim())
									: [];
							} else {
								customFieldValues[fieldKey] = item.value;
							}
						});

						form.setFieldsValue(customFieldValues);
					}

					setFileList(
						response.attachments.map((attachment) => ({
							key: attachment.id,
							uid: attachment.id,
							name: attachment.original_title,
							status: "done",
							url: attachment.filename,
						})),
					);
				}
			} catch (error) {
				if (error.response?.status === 500) {
					navigate("/sap-access-form");
				} else {
					console.log(error);
					notification.error({
						message: "Error fetching SAP Access Form",
						description: error.message,
					});
				}
			}
		};

		fetchData();
	}, [id, form, navigate]);

	useEffect(() => {
		const fetchDepartments = async () => {
			try {
				const response = await departmentService.getAllDepartments();
				setDepartmentOptions(
					response.map((dept) => ({
						label: dept.name, // Adjust based on your API response structure
						value: dept.id,
					})),
				);
			} catch (error) {
				console.error("Error fetching departments:", error);
				notification.error({
					message: "Failed to load departments",
					description: error.message,
				});
			}
		};

		fetchDepartments();
	}, []);
	useEffect(() => {
		const fetchDesignations = async () => {
			try {
				const response = await designationService.getAllDesignations();
				setDesignationOptions(
					response.map((designation) => ({
						label: designation.name,
						value: designation.id,
					})),
				);
			} catch (error) {
				console.error("Error fetching designations:", error);
			}
		};

		fetchDesignations();
	}, []);

	useEffect(() => {
		getCustomFields();
		const fetchEmployees = async () => {
			try {
				const apiResponse = await employeeService.getAllUsersList(); // Renamed for clarity

				if (
					apiResponse &&
					apiResponse.success &&
					Array.isArray(apiResponse.data)
				) {
					setEmployeeOptions(
						apiResponse.data.map((employee) => ({
							label: employee.name + " / " + employee.employee_no,
							value: employee.id,
							title: employee.email,
							name: employee.name,
						})),
					);
					setEmailOptions(
						apiResponse.data
							.filter((employee) => !!employee.email)
							.map((employee) => ({
								label: employee.email,
								value: employee.email,
								title: employee.name + " / " + employee.employee_no,
							})),
					);
				} else {
					console.error(
						"Error fetching employees: Invalid response format or unsuccessful request.",
						apiResponse,
					);
					setEmployeeOptions([]); // Set to empty array on error or invalid format
					notification.error({
						message: "Failed to load employees",
						description:
							apiResponse?.message ||
							"Received invalid data format from server.",
					});
				}
			} catch (error) {
				console.error("Error fetching employees:", error);
				notification.error({
					message: "Failed to load employees",
					description: error.message || "An unexpected error occurred.",
				});
				setEmployeeOptions([]); // Ensure options are cleared on network/API errors
			}
		};

		fetchEmployees();
	}, []);

	// SAP ID CONDITION
	const [isModification, setIsModification] = useState(false);

	const handleSapTypeChange = (value) => {
		form.setFieldsValue({ sap_access_type_id: value });
		let typeName = typeof value === "object" ? value?.name : value;
		if (typeof value === "number") {
			const found = sapTypes.find((t) => t.id === value);
			if (found) typeName = found.type;
		}

		setIsModification(
			typeName === "Modification" ||
				typeName === "Transfer of ID" ||
				typeName === "Sac ID" ||
				typeName === "SAP ID deactivation",
		);

		if (
			typeName === "Modification" ||
			typeName === "Transfer of ID" ||
			typeName === "Sac ID" ||
			typeName === "SAP ID deactivation"
		) {
			form.setFields([
				{
					name: "sap_id",
					errors: [],
				},
			]);
		} else {
			form.setFieldsValue({ sap_id: undefined });
		}
	};
	// SAP ID CONDITION

	// For Image
	const props = {
		onRemove: (file) => {
			const index = fileList.indexOf(file);
			const newFileList = fileList.slice();
			newFileList.splice(index, 1);
			handleRemoveAttachment(file);
			setFileList(newFileList);
		},
		beforeUpload: (file) => {
			setFileList((prevFileList) => {
				return prevFileList ? [...prevFileList, file] : [file];
			});
			return false;
		},
		fileList,
	};
	const handleRemoveAttachment = (file) => {
		setFileList((prevFileList) =>
			prevFileList.filter((f) => f.uid !== file.uid),
		);

		if (file.url) {
			setDeletedAttachments((prevDeleted) => [...prevDeleted, file.key]);
		}
	};

	// For Location
	const locationOptions = [
		{ id: 1, name: "Head Office" },
		{ id: 2, name: "Karachi Plant" },
		{ id: 3, name: "Pezu Plant" },
		{ id: 4, name: "Area Office" },
		{ id: 5, name: "Islamabad" },
		{ id: 6, name: "Lahore" },
		{ id: 7, name: "Peshawar" },
		{ id: 8, name: "Multan" },
		{ id: 9, name: "Faisalabad" },
		{ id: 10, name: "Quetta" },
	];
	const handleLocationChange = (values) => {
		// console.log('locationOnchange');
		// console.log(values);
		// console.log('locationOnchange');
		setSelectedLocations(values);
	};

	// For Plant

	const plantOptions = [
		{ id: 1, name: "PIBT" },
		{ id: 2, name: "QICT" },
		{ id: 3, name: "LCHO" },
		{ id: 4, name: "LCKP" },
		{ id: 5, name: "LCPZ" },
		{ id: 6, name: "LKPT" },
		{ id: 7, name: "PKGP" },
		{ id: 8, name: "PGPZ" },
	];
	const handlePlantChange = (values) => {
		// const valupdplant = values.map((id) => ({
		//   id: parseInt(id, 10), // Convert string to integer
		//   name: plantOptions.find((option) => option.id === parseInt(id, 10))?.name,
		// }));
		setSelectedPlants(values);
	};

	// For Validation OF Sections

	const onFinish = async (values) => {
		const {
			sales_distribution,
			material_management,
			plant_maintenance,
			financial_accounting_costing,
			production_planning,
			human_resource,
		} = values;
		// if (
		// 	(editMode && formattedData.status === "Pending") ||
		// 	(editMode &&
		// 		(!sales_distribution || sales_distribution.length === 0) &&
		// 		(!material_management || material_management.length === 0) &&
		// 		(!plant_maintenance || plant_maintenance.length === 0) &&
		// 		(!financial_accounting_costing ||
		// 			financial_accounting_costing.length === 0) &&
		// 		(!production_planning || production_planning.length === 0) &&
		// 		(!human_resource || human_resource.length === 0))
		// ) {
		// 	message.error(
		// 		"Please fill out at least one tab (SD, MM,, PM, FICO, PP, or HR)"
		// 	);
		// 	return;
		// }
		if (editMode && formattedData.status === "Pending") {
			const allTabsEmpty =
				(!sales_distribution || sales_distribution.length === 0) &&
				(!material_management || material_management.length === 0) &&
				(!plant_maintenance || plant_maintenance.length === 0) &&
				(!financial_accounting_costing ||
					financial_accounting_costing.length === 0) &&
				(!production_planning || production_planning.length === 0) &&
				(!human_resource || human_resource.length === 0);

			if (allTabsEmpty) {
				message.error(
					"Please fill out at least one tab (SD, MM, PM, FICO, PP, or HR)",
				);
				return;
			}
		}

		try {
			setLoading(true);
			values.save_as_draft = String(isDraft);

			//  HANDLE CUSTOM FIELDS
			const customFields = {};
			Object.keys(values).forEach((key) => {
				if (key.startsWith("field_")) {
					const fieldId = key.replace("field_", "");
					customFields[fieldId] = Array.isArray(values[key])
						? values[key].join(",")
						: values[key];
				}
			});
			if (Object.keys(customFields).length > 0) {
				values.custom_fields = customFields;
			}
			//  END CUSTOM FIELDS

			let typeId =
				typeof values.sap_access_type_id === "object"
					? values.sap_access_type_id?.id
					: values.sap_access_type_id;

			// Safeguard: if typeId is string, try to map it to ID
			if (typeof typeId === "string") {
				const found = sapTypes.find(
					(t) => t.type === typeId || t.name === typeId,
				);
				if (found) {
					typeId = found.id;
				} else if (!isNaN(parseInt(typeId, 10))) {
					typeId = parseInt(typeId, 10);
				}
			}

			// Create FormData for request
			const formData = new FormData();

			// Append form values (skip sap_access_type_id, location, plant - handled separately)
			Object.keys(values).forEach((key) => {
				if (
					key === "sap_access_type_id" ||
					key === "location" ||
					key === "plant" ||
					key === "sap_id"
				) {
					// Skip these, handled separately
					return;
				}
				if (Array.isArray(values[key])) {
					values[key].forEach((item, index) => {
						formData.append(`${key}[${index}]`, item || "");
					});
				} else {
					formData.append(key, values[key] || "");
				}
			});

			// Append location data
			selectedLocations.forEach((locId, index) => {
				const locName = locationOptions.find((opt) => opt.id === locId)?.name;
				formData.append(`location[${index}][id]`, locId);
				formData.append(`location[${index}][name]`, locName || "");
			});

			// Append plant data
			selectedPlants.forEach((plantId, index) => {
				const plantName = plantOptions.find((opt) => opt.id === plantId)?.name;
				formData.append(`plant[${index}][id]`, plantId);
				formData.append(`plant[${index}][name]`, plantName || "");
			});

			// Append designation and employee names
			const selectedDesignation = designationOptions.find(
				(opt) => opt.value === values.for_designation,
			);
			const selectedEmployee = employeeOptions.find(
				(opt) => opt.value === values.for_employee,
			);

			if (selectedDesignation) {
				formData.set("for_designation", selectedDesignation.label);
			}
			if (selectedEmployee) {
				formData.set(
					"for_employee",
					selectedEmployee.name || selectedEmployee.label,
				);
			}

			// Append SAP type ID
			formData.set("sap_access_type_id", typeId ?? "");
			formData.set("save_as_draft", values.save_as_draft);

			// Append SAP ID if present
			if (isModification && values.sap_id) {
				formData.set("sap_id", values.sap_id.trim());
			}

			// Append attachments (new files only)
			if (fileList) {
				fileList.forEach((file, index) => {
					if (!file.url) {
						// Check if the file is new (not from backend)
						formData.append(
							`attachments[${index}]`,
							file.originFileObj || file,
						);
					}
				});
			}

			// Append deleted attachments
			deletedAttachments.forEach((attachmentId, index) => {
				formData.append(`deleted_attachments[${index}]`, attachmentId);
			});

			if (editMode) {
				const response = await sapService.updateSapForm(id, formData);
				if (response.success) {
					setEditMode(false);
					setEditingEquipmentRequest(null);
					setDeletedAttachments([]);
					notification.success({
						message: "Sap Access Form Updated",
						description: response.message,
					});
					navigate("/sap-access-form");
				}
			} else {
				const response = await sapService.postSapRequest(formData);

				if (response.success) {
					form.resetFields();
					setFileList([]);
					setDeletedAttachments([]);
					notification.success({
						message: "Sap Access Form Added",
						description: response.message,
					});
					navigate("/sap-access-form");
				}
			}
		} catch (error) {
			console.log(error);
			notification.error({
				message: "Sap Access Form Operation Failed",
				description: error.response?.data?.message || error.message,
			});
		} finally {
			setLoading(false);
		}
	};

	const getCurrentUser = async () => {
		setLoading(true);
		try {
			const response = await userService.getCurrentUser(currentUser.user_id);
			//console.log(response);
			form.setFieldsValue({
				name: response.name,
				email: response.email,
				designation_id: response.designation.name,
				employee_no: response.employee_no,
				employee_type: response.employee_type,
				extension: response.extension,
				phone_number: response.phone_number,
				profile_location: response.location.name,
				role_id: response.roles.map((role) => role.id),
				// department_id: response.department.name,
				section_id: response.section.name,
			});
		} catch (error) {
		} finally {
			setLoading(false);
		}
	};

	const validateCheckboxGroup = (_, values) => {
		if (values && values.length > 0) {
			return Promise.resolve();
		}
		return Promise.reject(new Error("Please select at least one requirement."));
	};

	useEffect(() => {
		getCurrentUser();
	}, []);

	return (
		<DefaultLayout>
			<Row gutter={[24, 24]}>
				<Col span={24}>
					<Header icon={<FileTextOutlined />} title='SAP Access Form' />
				</Col>
			</Row>
			<Card>
				<Form
					autoComplete='off'
					onFinish={onFinish}
					onFinishFailed={() => setLoading(false)}
					form={form}
					layout='vertical'
					scrollToFirstError
					className='mt-20'
					initialValues={{
						for_department: String(defaultDeparmentName), // your default department id
					}}
				>
					<div spinning={loading}>
						<Card
							size='small'
							className='mb-10'
							title='To be filled by Requestor'
						>
							<Row gutter={[12, 12]}>
								<Col lg={8} md={8} sm={24} xs={24}>
									<Form.Item
										name='request_title'
										label='Request Title'
										rules={[{ required: true, message: "Type Request Title" }]}
									>
										<Input
											placeholder='Type Request Title'
											size='large'
											allowClear
										/>
									</Form.Item>
								</Col>
								<Col lg={8} md={8} sm={24} xs={24}>
									<Form.Item
										name='company_id'
										label='Company'
										rules={[
											{
												required: true,
												message: "Please select a Company",
											},
										]}
									>
										<CompanyComponent all={true} />
									</Form.Item>
								</Col>

								<Col lg={8} md={8} sm={24} xs={24}>
									<Form.Item
										name='location'
										label='Location'
										// rules={[
										//   { required: true, message: 'Please select a location' },
										// ]}
									>
										<SapLocationComponent
											value={selectedLocations}
											onChange={handleLocationChange}
										/>
									</Form.Item>
								</Col>
							</Row>

							{/* New Dropdowns and Email Textbox */}
							<Row gutter={[12, 12]}>
								<Col lg={6} md={12} sm={24} xs={24}>
									<Form.Item
										name='for_department'
										label='For Department'
										rules={[
											{ required: true, message: "Please select a Department" },
										]}
									>
										<Select
											style={{ width: "100%" }}
											options={departmentOptions}
											placeholder='Select Department'
											size='large'
											showSearch
											filterOption={(inputValue, option) =>
												option.label
													.toUpperCase()
													.indexOf(inputValue.toUpperCase()) !== -1
											}
											allowClear
										/>
									</Form.Item>
								</Col>
								<Col lg={6} md={12} sm={24} xs={24}>
									<Form.Item
										name='for_designation'
										label='For Designation'
										rules={[
											{
												required: true,
												message: "Please select a Designation",
											},
										]}
									>
										<Select
											style={{ width: "100%" }}
											options={designationOptions}
											placeholder='Select Designation'
											size='large'
											showSearch
											filterOption={(inputValue, option) =>
												option.label
													.toUpperCase()
													.indexOf(inputValue.toUpperCase()) !== -1
											}
											allowClear
										/>
									</Form.Item>
								</Col>
								<Col lg={6} md={12} sm={24} xs={24}>
									<Form.Item
										name='for_employee'
										label='For Employee'
										rules={[
											{ required: true, message: "Please select an Employee" },
										]}
									>
										<Select
											style={{ width: "100%" }}
											options={employeeOptions}
											placeholder='Select Employee'
											size='large'
											showSearch
											filterOption={(inputValue, option) =>
												option.label
													.toUpperCase()
													.indexOf(inputValue.toUpperCase()) !== -1
											}
											allowClear
										/>
									</Form.Item>
								</Col>
								<Col lg={6} md={12} sm={24} xs={24}>
									<Form.Item
										name='for_email'
										label='For Email'
										rules={[
											{ required: true, message: "Please enter an Email" },
											{ type: "email", message: "Please enter a valid Email" },
										]}
									>
										<AutoComplete
											style={{ width: "100%" }}
											options={emailOptions}
											placeholder='Select or enter Email'
											size='large'
											filterOption={(inputValue, option) =>
												option.value
													.toUpperCase()
													.indexOf(inputValue.toUpperCase()) !== -1
											}
											allowClear
										/>
									</Form.Item>
								</Col>
							</Row>

							<Row gutter={[12, 12]}>
								<Col lg={12} md={12} sm={24} xs={24}>
									<Form.Item
										name='sap_access_type_id'
										label='Type'
										rules={[
											{ required: true, message: "Please select a Type" },
										]}
									>
										<SapTypeComponent onChange={handleSapTypeChange} />
									</Form.Item>
								</Col>

								{isModification && (
									<Col lg={12} md={12} sm={24} xs={24}>
										<Form.Item
											name='sap_id'
											label='SAP/SAC ID:'
											rules={[
												...(isModification
													? [
															{
																required: true,
																message: "Required Transfer of ID:",
															},
															{
																validator: (_, value) => {
																	if (!value) return Promise.reject();
																	const trimmedValue = value.trim();
																	if (trimmedValue.length < 2) {
																		return Promise.reject(
																			new Error(
																				"ID must be at least 2 characters long!",
																			),
																		);
																	}
																	return Promise.resolve();
																},
															},
														]
													: []),
											]}
										>
											<Input
												placeholder='ID:'
												size='large'
												disabled={!isModification}
												onChange={(e) => {
													const trimmedValue = e.target.value.trim();
													form.setFieldsValue({ sap_id: trimmedValue });
												}}
											/>
										</Form.Item>
									</Col>
								)}
							</Row>
						</Card>

						<Card
							size='small'
							className='mb-10'
							title='Required ID & Access on Module(s)'
						>
							<Row gutter={[12, 12]}>
								<Col lg={8} md={8} sm={24} xs={24}>
									<Form.Item
										name='roles_required'
										label='Roles Required'
										// rules={[{ required: true, message: 'Type Roles Required:' }]}
									>
										<Input
											placeholder='Type Roles Required:'
											size='large'
											allowClear
										/>
									</Form.Item>
								</Col>
								<Col lg={8} md={8} sm={24} xs={24}>
									<Form.Item
										name='tcode_required'
										label='T.Code Required'
										// rules={[{ required: true, message: 'Type T.Code Required:' }]}
									>
										<Input
											placeholder='Type T.Code Required:'
											size='large'
											allowClear
										/>
									</Form.Item>
								</Col>
								<Col lg={8} md={8} sm={24} xs={24}>
									<Form.Item
										name='plant'
										label='Plant'
										// rules={[
										//   { required: true, message: 'Please select a Plant' },
										// ]}
									>
										<SapPlantComponent
											value={selectedPlants}
											onChange={handlePlantChange}
										/>
										;
									</Form.Item>
								</Col>
							</Row>

							<Row gutter={[12, 12]}>
								<Col lg={24} md={24} sm={24} xs={24}>
									<Form.Item
										name='business_justification'
										label='Business Justification'
										// rules={[{ required: true, message: 'Type Business Justification' }]}
									>
										<Input.TextArea
											rows={4}
											size='large'
											placeholder={`Enter Business Justification`}
										/>
									</Form.Item>
								</Col>
							</Row>
						</Card>
						{/* ATTACHMENT */}
						<Card size='small' className='mb-10' title='Attachment(s)'>
							<Row gutter={[12, 12]}>
								<Col span={24} className='mb-40'>
									<Upload.Dragger
										multiple
										{...props}
										onRemove={(file) => handleRemoveAttachment(file)}
									>
										<p className='ant-upload-drag-icon'>
											<InboxOutlined />
										</p>
										<p className='ant-upload-text'>
											Click or drag files to this area to upload
										</p>
									</Upload.Dragger>
								</Col>
							</Row>
						</Card>
						{/* END ATTACHMENT */}
						{editMode &&
							formattedData?.draft_at === null &&
							formattedData?.status === "Pending" &&
							currentUser?.user_id !== formattedData?.created_by && (
								<Card
									size='small'
									className='mb-10 filledByRelatedDepartment'
									title='Module(s) Other Details'
								>
									{/* Tabs for distinct sections */}
									<Tabs defaultActiveKey='1' className='mb-10 ml-10 mr-10'>
										{/* Sales and Distribution (SD) Section */}
										<TabPane tab='Sales and Distribution (SD)' key='1'>
											<Card size='small'>
												<Row gutter={[12, 12]}>
													<Col lg={8} sm={24}>
														{/*  <Form.Item
                      name={['sales_distribution',0,'sales_organization']}
                      label="Sales Organization"
                      rules={[]}
                    >
                      <Input placeholder="Enter Sales Organization" />
                    </Form.Item>*/}
														<Form.Item
															name={[
																"sales_distribution",
																0,
																"sales_organization",
															]}
															label='Sales Organization'
															rules={[]}
														>
															<ParamComponent
																type={"saf_sd_sales_organization"}
																all={true}
																compId={compId}
															/>
														</Form.Item>
													</Col>
													<Col lg={8} sm={24}>
														<Form.Item
															name={[
																"sales_distribution",
																0,
																"distribution_channel",
															]}
															label='Distribution Channel'
														>
															<ParamComponent
																type={"saf_sd_distribution_channel"}
																all={true}
																compId={compId}
															/>
														</Form.Item>
													</Col>
													<Col lg={8} sm={24}>
														<Form.Item
															name={["sales_distribution", 0, "division"]}
															label='Division'
															rules={[]}
														>
															<ParamComponent
																type={"saf_sd_division"}
																all={true}
																compId={compId}
															/>
														</Form.Item>
													</Col>
													<Col lg={12} sm={24}>
														<Form.Item
															name={["sales_distribution", 0, "sales_office"]}
															label='Sales Office'
															rules={[]}
														>
															<ParamComponent
																type={"saf_sd_sales_office"}
																all={true}
																compId={compId}
															/>
														</Form.Item>
													</Col>
													<Col lg={12} sm={24}>
														<Form.Item
															name={["sales_distribution", 0, "sales_group"]}
															label='Sales Group'
															rules={[]}
														>
															<ParamComponent
																type={"saf_sd_sales_group"}
																all={true}
																compId={compId}
															/>
														</Form.Item>
													</Col>
													<Col span={24}>
														<Form.Item
															name={["sales_distribution", 0, "other_details"]}
															label='Other Details'
															rules={[]}
														>
															<Input.TextArea
																rows={4}
																placeholder='Enter Other Details'
															/>
														</Form.Item>
													</Col>
												</Row>
											</Card>
										</TabPane>

										{/* Material Management (MM) Section */}
										<TabPane tab='Material Management (MM)' key='2'>
											<Card size='small'>
												<Row gutter={[12, 12]}>
													<Col lg={12} sm={24}>
														<Form.Item
															name={[
																"material_management",
																0,
																"purchasing_org",
															]}
															label='Purchasing Org'
															rules={[]}
														>
															<ParamComponent
																type={"saf_mm_purchasing_org"}
																all={true}
																compId={compId}
															/>
														</Form.Item>
													</Col>
													<Col lg={12} sm={24}>
														<Form.Item
															name={[
																"material_management",
																0,
																"purchasing_group",
															]}
															label='Purchasing Group'
															rules={[]}
														>
															<ParamComponent
																type={"saf_mm_purchasing_group"}
																all={true}
																compId={compId}
															/>
														</Form.Item>
													</Col>
													<Col lg={12} sm={24}>
														<Form.Item
															name={[
																"material_management",
																0,
																"storage_location",
															]}
															label='Storage Location'
															rules={[]}
														>
															<Input
																placeholder='Storage Location'
																size='large'
															/>

															{/*<ParamComponent type={'saf_mm_storage_location'} all={true}  compId={compId}  />*/}
														</Form.Item>
													</Col>
													<Col lg={12} sm={24}>
														<Form.Item
															name={[
																"material_management",
																0,
																"purchasing_document",
															]}
															label='Purchasing Document'
															rules={[]}
														>
															<Input
																placeholder='Purchasing Document'
																size='large'
															/>

															{/*<ParamComponent type={'saf_mm_purchasing_document'} all={true}  compId={compId}  />*/}
														</Form.Item>
													</Col>
													<Col lg={12} sm={24}>
														<Form.Item
															name={["material_management", 0, "movement_type"]}
															label='Movement Type'
															rules={[]}
														>
															<Input placeholder='Movement Type' size='large' />

															{/*<ParamComponent type={'saf_mm_movement_type'} all={true}  compId={compId}  />*/}
														</Form.Item>
													</Col>
													<Col span={24}>
														<Form.Item
															name={["material_management", 0, "other_details"]}
															label='Other Details'
															rules={[]}
														>
															<Input.TextArea
																rows={4}
																placeholder='Enter Other Details'
															/>
														</Form.Item>
													</Col>
												</Row>
											</Card>
										</TabPane>

										{/* Plant Maintenance (PM) Section */}
										<TabPane tab='Plant Maintenance (PM)' key='3'>
											<Card size='small'>
												<Row gutter={[12, 12]}>
													<Col span={8}>
														<Form.Item
															name={["plant_maintenance", 0, "planning_plant"]}
															label='Planning Plant'
															rules={[]}
														>
															<ParamComponent
																type={"saf_pm_planning_plant"}
																all={true}
																compId={compId}
															/>
														</Form.Item>
													</Col>
													<Col span={8}>
														<Form.Item
															name={[
																"plant_maintenance",
																0,
																"maintenance_plant",
															]}
															label='Maintenance Plant'
															rules={[]}
														>
															<ParamComponent
																type={"saf_pm_maintenance_plant"}
																all={true}
																compId={compId}
															/>
														</Form.Item>
													</Col>
													<Col span={8}>
														<Form.Item
															name={["plant_maintenance", 0, "work_centers"]}
															label='Work Centers'
															rules={[]}
														>
															<ParamComponent
																type={"saf_pm_work_center"}
																all={true}
																compId={compId}
															/>
														</Form.Item>
													</Col>
													<Col span={24}>
														<Form.Item
															name={["plant_maintenance", 0, "other_details"]}
															label='Other Details'
															rules={[]}
														>
															<Input.TextArea
																rows={4}
																placeholder='Enter Other Details'
															/>
														</Form.Item>
													</Col>
												</Row>
											</Card>
										</TabPane>

										{/* Financial Accounting & Costing (FICO) Section */}
										<TabPane
											tab='Financial Accounting & Costing (FICO)'
											key='4'
										>
											<Card size='small'>
												<Row gutter={[12, 12]}>
													<Col span={12}>
														<Form.Item
															name={[
																"financial_accounting_costing",
																0,
																"profile_center",
															]}
															label='Profile Center'
															rules={[]}
														>
															<ParamComponent
																type={"saf_fico_profit_center"}
																all={true}
																compId={compId}
															/>
														</Form.Item>
													</Col>
													<Col span={12}>
														<Form.Item
															name={[
																"financial_accounting_costing",
																0,
																"cost_center",
															]}
															label='Cost Center'
															rules={[]}
														>
															<ParamComponent
																type={"saf_fico_cost_center"}
																all={true}
																compId={compId}
															/>
														</Form.Item>
													</Col>
													<Col span={24}>
														<Form.Item
															name={[
																"financial_accounting_costing",
																0,
																"other_details",
															]}
															label='Other Details'
															rules={[]}
														>
															<Input.TextArea
																rows={4}
																placeholder='Enter Other Details'
															/>
														</Form.Item>
													</Col>
												</Row>
											</Card>
										</TabPane>

										{/* Production Planning (PP) Section */}
										<TabPane tab='Production Planning (PP)' key='5'>
											<Card size='small'>
												<Form.Item
													name={["production_planning", 0, "other_details"]}
													label='Other Details'
													rules={[]}
												>
													<Input.TextArea
														rows={4}
														placeholder='Enter Other Details'
													/>
												</Form.Item>
											</Card>
										</TabPane>

										{/* Human Resource (HR) Section */}
										<TabPane tab='Human Resource (HR)' key='6'>
											<Card size='small'>
												<Row gutter={[12, 12]}>
													<Col lg={8} sm={24}>
														<Form.Item
															name={["human_resource", 0, "personnel_area"]}
															label='Personnel Area'
															rules={[]}
														>
															<ParamComponent
																type={"saf_hr_personnel_area"}
																all={true}
																compId={compId}
															/>
														</Form.Item>
													</Col>
													<Col lg={8} sm={24}>
														<Form.Item
															name={["human_resource", 0, "sub_area"]}
															label='Sub Area'
															rules={[]}
														>
															<ParamComponent
																type={"saf_hr_sub_area"}
																all={true}
																compId={compId}
															/>
														</Form.Item>
													</Col>
													<Col lg={8} sm={24}>
														<Form.Item
															name={["human_resource", 0, "cost_center"]}
															label='Cost Center'
															rules={[]}
														>
															<ParamComponent
																type={"saf_hr_cost_center"}
																all={true}
																compId={compId}
															/>
														</Form.Item>
													</Col>
													<Col lg={12} sm={24}>
														<Form.Item
															name={["human_resource", 0, "employee_group"]}
															label='Employee Group'
															rules={[]}
														>
															<ParamComponent
																type={"saf_hr_employee_group"}
																all={true}
																compId={compId}
															/>
														</Form.Item>
													</Col>
													<Col lg={12} sm={24}>
														<Form.Item
															name={["human_resource", 0, "employee_sub_group"]}
															label='Employee Sub Group'
															rules={[]}
														>
															<ParamComponent
																type={"saf_hr_employee_sup_group"}
																all={true}
																compId={compId}
															/>
														</Form.Item>
													</Col>
													<Col span={24}>
														<Form.Item
															name={["human_resource", 0, "other_details"]}
															label='Other Details'
															rules={[]}
														>
															<Input.TextArea
																rows={4}
																placeholder='Enter Other Details'
															/>
														</Form.Item>
													</Col>
												</Row>
											</Card>
										</TabPane>
									</Tabs>
								</Card>
							)}
						{/* Render Custom Fields */}
						<RenderCustomFields
							customfields={customfields}
							dynamicOptions={dynamicOptions}
							fetchDynamicOptions={fetchDynamicOptions}
						/>

						<Row gutter={[12, 12]} className='mt-40'>
							<Col span={24} className='text-right'>
								<div
									style={{ display: "flex", justifyContent: "space-between" }}
									className='mt-24'
								>
									<Button
										type='primary'
										block
										disabled={loading}
										loading={loading}
										className='btn-blue mr-20'
										onClick={() => {
											setLoading(true);
											setIsDraft(false);
											form.submit();
										}}
									>
										Save & Publish
									</Button>
									{(editMode && formattedData?.status === "Return") ||
									!editMode ? (
										<Button
											disabled={loading}
											loading={loading}
											type='primary'
											onClick={() => {
												setLoading(true);
												setIsDraft(true);
												form.submit();
											}}
										>
											Save Draft
										</Button>
									) : null}
								</div>
							</Col>
						</Row>
					</div>
				</Form>
			</Card>
		</DefaultLayout>
	);
};

export default PostEquipmentRequest;
